import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { addPartner } from "features/Promotion/promotionSlice";
import { useForm } from "react-hook-form";
import {
  Age,
  FirstName,
  LastName,
  GenderAdd,
  Phone,
  PromotionSetField,
  checkPromotionSets,
  FirstNameKana,
  LastNameKana,
  Email,
} from "features/Promotion/field-input";

const ModalAddPartner = ({ closeFn, open = null }) => {
  const dispatch = useDispatch();
  const [errorDisplay, setErrorDisplay] = useState([]);

  let errorValidate = [];
  const { promotion_set, promotion } = useSelector((state) => state.promotion);

  const {
    register,
    formState: { errors },
    handleSubmit,
    reset,
    } = useForm({
    defaultValues: {
      promotion_set_id: promotion.split_flg == 1 ? [] : [""+promotion_set[0].id],
    },
  });

  // check partner validate : age/ gender
  const checkPartner = (data) => {
    errorValidate = [];
    const { age, gender, promotion_set_id } = data;

    errorValidate = checkPromotionSets(
      promotion,
      promotion_set_id,
      age,
      gender
    );

    setErrorDisplay(errorValidate);
    return errorValidate.length < 1 ? true : false;
  };

  const handleClearErrorAge = () => {
    if (errorDisplay) {
      setErrorDisplay([]);
    }
  };


  const onSubmit = (data, e) => {
    if (checkPartner(data)) {
      dispatch(addPartner(data));
      setErrorDisplay([]);
      closeFn(e);
      reset();
    }
  };

  const closeModal = (e) => {
    errorValidate = [];
    setErrorDisplay([]);
    closeFn(e);
    reset();
  };

  return (
    open && (
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="modal active rounded-8"
      >
        <div className="modal-body">
          <div className="title mt-2 text-black">
            追加する同行者の情報をご入力ください
          </div>

          <div className="px-3 px-md-5 my-4">
            {errorDisplay.length > 0 &&
              errorDisplay.map((err, index) => (
                <div key={index} className="alert alert-danger mt-2">
                  {err}
                </div>
              ))}

            <div className="my-3">
              <div className="form-group">
                <label className="mb-2">
                  お名前<span>[必須]</span>
                </label>
                <div className="row gx-3">
                  <div className="col-12 col-md-6">
                    <LastName register={register} errors={errors} />
                  </div>
                  <div className="col-12 col-md-6 mt-2 mt-md-0">
                    <FirstName register={register} errors={errors} />
                  </div>
                </div>
                <div className="row gx-3 mt-2">
                  <div className="col-12 col-md-6">
                    <LastNameKana register={register} errors={errors} />
                  </div>
                  <div className="col-12 col-md-6 mt-2 mt-md-0">
                    <FirstNameKana register={register} errors={errors} />
                  </div>
                </div>
              </div>
            </div>

            <div className="my-3">
              <div className="form-group">
                <label className="mb-2">
                  年齢<span>[必須]</span> <span>半角数字</span>
                </label>
                <div className="row gx-3">
                  <div className="w-82 col-md-2">
                    <Age
                      register={register}
                      errors={errors}
                      errorAge={errorDisplay.length > 0 ? true : false}
                      clearError={handleClearErrorAge}
                    />
                  </div>
                </div>
                {errors?.age && (
                  <div className="alert alert-danger mt-2">
                    {errors.age?.message}
                  </div>
                )}
              </div>
            </div>
            <div className="my-3">
              <div className="form-group">
                <label className="mb-2">
                  性別<span>[必須]</span>
                </label>
                <div>
                  <GenderAdd
                    register={register}
                    value="1"
                    id="1"
                    label="男性"
                    errors={errors}
                  />
                  <GenderAdd
                    register={register}
                    value="2"
                    id="2"
                    label="女性"
                    errors={errors}
                  />
                </div>
                {errors?.gender && (
                  <div className="alert alert-danger mt-2">
                    {errors.gender?.message}
                  </div>
                )}
              </div>
            </div>
            <div className="my-3">
              <div className="form-group">
                <label className="mb-2">
                  電話番号<span>[必須]</span>
                  <span>半角数字・ハイフンなし</span>
                </label>
                <div className="row gx-2">
                  <div className="col-12 col-md-9">
                    <Phone register={register} errors={errors} />
                  </div>
                </div>
              </div>
            </div>
            <div className="my-3">
              <div className="form-group">
                <label className="mb-2">
                メールアドレス<span></span>
                  <span></span>
                </label>
                <div className="row gx-2">
                  <div className="col-12 col-md-9">
                    <Email register={register} errors={errors} />
                  </div>
                </div>
              </div>
            </div>

            {/* check promotion set */}
            {promotion?.split_flg == 1 && promotion_set && (
              <div className="my-3">
                <div className="form-group">
                  <label>
                    同行者の参加時間<span>[必須]</span>
                  </label>
                  <div className="fw-600 my-2">
                    {promotion_set?.map((item) => {
                        return (
                          <div key={item.id} className="my-1">
                            <div className="bg-violet border-radius-3 px-3 py-2">
                              <PromotionSetField
                                register={register}
                                promotionset={item}
                              />
                            </div>
                          </div>
                        );
                    })}
                    <div key="test" className="my-1">
                    </div>
                    {errors?.promotion_set_id && (
                      <div className="alert fw-400 alert-danger mt-2">
                        {errors.promotion_set_id?.message}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="d-flex justify-content-center fw-700 fs-12 flex-wrap text-red">
            <span> ※身分証を確認させて頂く場合がございます。 </span>
            <span> お間違えのない様にお願いいたします。 </span>
          </div>

          <div className="my-3 text-center">
            <button type="submit" className="btn-custom red-light">
              追加する
            </button>

            <div onClick={closeModal} className="btn-custom mt-2">
              キャンセル
            </div>
          </div>
        </div>
      </form>
    )
  );
};

export default ModalAddPartner;
